import * as IF from "infrontjs";
import { StartState } from "../states/StartState.js";
import { GameState } from "../states/GameState.js";
import { StatState } from "../states/StatState.js";
import { HelpState } from "../states/HelpState.js";
import { SettingsState } from "../states/SettingsState.js";
import { ImprintState } from "../states/ImprintState.js";
import { PrivacyState } from "../states/PrivacyState.js";
import { TosState } from "../states/TosState.js";
import { getCoins } from "../data/coins.js";

export class App extends IF.App
{
    constructor( container )
    {
        const config = {
            app: {
                title: 'Daily Minesweeper Quest',
                sayHello: false
            },
            router: {
                mode: 'hash'
            },
            states: {
                useDefaultIndexState: false,
                useDefaultNotFoundState: false
            }
        };

        super( container, config );

        this.states.add( StartState );
        this.states.add( GameState );
        this.states.add( StatState );
        this.states.add( HelpState );
        this.states.add( SettingsState );
        this.states.add( ImprintState );
        this.states.add( PrivacyState );
        this.states.add( TosState );
    }

    async run( route = null )
    {
        getCoins();
        await super.run( route );
    }
};
